'use client';

import { __awaiter, __generator } from '../_virtual/_tslib.js';
import { ELanguage } from '../Utils/constants.js';

var DEFAULT_SUCCESS_CODE = 200;
var DEFAULT_ERROR_CODE = 400;
var followCompany = function (companyId, isFollow, api, accessToken, langCode) { return __awaiter(void 0, void 0, void 0, function () {
    var postData, requestOptions, response, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                postData = {
                    companyId: companyId,
                    status: isFollow ? 1 : 0
                };
                requestOptions = {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': langCode || ELanguage.VI,
                        Authorization: "Bearer ".concat(accessToken)
                    },
                    body: JSON.stringify(postData)
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_1 = _a.sent();
                console.error(err_1);
                return [2 /*return*/, {
                        meta: {
                            code: DEFAULT_ERROR_CODE,
                            message: 'ERROR'
                        },
                        data: null
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };
var getRecommendCompanyList = function (api) { return __awaiter(void 0, void 0, void 0, function () {
    var requestOptions, response, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                };
                return [4 /*yield*/, fetch(api, requestOptions)];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _a.sent()];
            case 3:
                err_2 = _a.sent();
                console.error(err_2);
                return [2 /*return*/, {
                        companies: []
                    }];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { DEFAULT_ERROR_CODE, DEFAULT_SUCCESS_CODE, followCompany, getRecommendCompanyList };
//# sourceMappingURL=apiServices.js.map
